import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { Button, Col, Row } from 'virtues-bootstrap';

import { PATIENT, SUPER_RESEARCHER } from 'constants/userRoles';
import { UserRoleType } from 'types';
import { ReactComponent as IconFileSolid } from 'svg/file-solid.svg';

import useExport from 'hook/useExport';
import { requestDeviceReports } from 'services/api/request/exports';

import s from './styles.module.scss';

import { getTitleByRole, isResearcher } from '../utils';

const PageHeader = ({ patientId, patientName, role, t }) => {
  const title = getTitleByRole(role);
  const isExportBtn = isResearcher(role);
  const [setLoadingExport] = useExport(requestDeviceReports, patientId);

  return (
    <Row className={s.root}>
      <Col xs={3} />
      <Col xs={6} className={s.title}>
        <h1>{t(title)}</h1>
        {role !== PATIENT && (
          <div className={s.subTitle}>
            {role !== SUPER_RESEARCHER && <h3>{patientName}</h3>}
            <h3>{`RPM-CIED-${patientId}`}</h3>
          </div>
        )}
      </Col>
      <Col xs={3} className={s.exportBtn}>
        {isExportBtn && (
          <Button
            onClick={() => setLoadingExport(true)}
            icon={<IconFileSolid />}
            variant="primary"
            outlined
          >
            {t('patient.exportData')}
          </Button>
        )}
      </Col>
    </Row>
  );
};

PageHeader.propTypes = {
  role: UserRoleType.isRequired,
  patientName: PropTypes.string,
  patientId: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

PageHeader.defaultProps = {
  patientName: null,
};

export default withTranslation()(PageHeader);
